import { VoiceTunables } from "./consts";

// Standalone on purpose. If energy thresholding proves inadequate in noisy field conditions, a
// neural VAD (Silero via ONNX Runtime Web) drops in behind this call and nothing else moves —
// so never inline the threshold comparison at a call site.
//
// Thresholds arrive as a resolved snapshot rather than being read here: this runs on the 20ms
// analyser tick, and reading localStorage per frame is what readVoiceTunables exists to avoid.
const isSpeech = (rms: number, currentlySpeaking: boolean, tunables: VoiceTunables): boolean =>
  rms > (currentlySpeaking ? tunables.SPEECH_STAY_RMS : tunables.SPEECH_ENTER_RMS);

// Deliberately not `!isSpeech(...)`: one frame under STAY drops the speech latch, and re-entry
// then demands the higher ENTER threshold, so quiet-but-continuous speech banks silence while the
// rep is still talking. The silence timer has to measure the level, never the latch.
export const isSilent = (rms: number, tunables: VoiceTunables): boolean =>
  rms <= tunables.SPEECH_STAY_RMS;

export default isSpeech;
